import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { Router } from '@angular/router';
import { AppService } from '../../../app.service';
import { ConfigAddMontlyDashbrdMessageComponent } from '../config-add-montly-dashbrd-message/config-add-montly-dashbrd-message.component';
import { ConfigAddTakeComponent } from '../config-add-take/config-add-take.component';
import { ConfigAddToolboxTalkComponent } from '../config-add-toolbox-talk/config-add-toolbox-talk.component';
import { EnterSafetyInspectionDialogComponent } from '../enter-safety-inspection-dialog/enter-safety-inspection-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
    private _router:Router,
    private _appService: AppService, 
    public dialog: MatDialog
  ) { }

  ngOnInit() {
   // private _appService: AppService, 
    this._appService.setPageTitle('Safety Dashboard');
   // this._appService.setPageSubTitle('');



  }

  //open enter-safety-level-dialog
 
  openSafetyInspectionDialog(){
    const dialogRef = this.dialog.open(EnterSafetyInspectionDialogComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }
  openConfigAddTakeDialog(){
    const dialogRef = this.dialog.open(ConfigAddTakeComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }
  //ConfigAddToolboxTalkComponent
  openConfigAddToolboxTalkDialog(){
    const dialogRef = this.dialog.open(ConfigAddToolboxTalkComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }
  //ConfigAddMontlyDashbrdMessageComponent
  openConfigAddMonthlyDashMessageDialog(){
    const dialogRef = this.dialog.open(ConfigAddMontlyDashbrdMessageComponent, { 
      disableClose: true,
      data:{

      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
 
      console.log('The dialog was closed');
     }
   });
  }

  //navigate to perform Induction page
  NavigateToPerformInductionPage(){
    this._router.navigate(['/performinduction']);
  }

  //navigate to setup Induction Types and Section
  NavigateToSetupInductionTypesAndSectionPage(){
    this._router.navigate(['/configsetupinductionsection']);
  }
  NavigateToSetupInductionQuestion(){
    this._router.navigate(['/setup/inductionquestion']);
    
  }

  NavigateToSetupInductionSlide(){
    this._router.navigate(['/setupinductionslide']);
    
  }
  NavigateToSetupInductionSearch(){
    this._router.navigate(['/searchinduction']);
    
  }
  NavigateToSafetyInspectionSearch(){
    this._router.navigate(['/safetyinspection/search']);
  }

  NavigateToSafetyObservationPointDashbord(){
    this._router.navigate(['/safetyobservationdashboardcomponent']);

  }

  NavigateToSafetyIndicatorsComponent(){
    this._router.navigate(['/safetyindicatorscomponent']);

  }

  NavigateToSafetyGeneralDashboardComponent(){
    this._router.navigate(['/safetygeneraldashboardcomponent']);

  }

  NavigateToSetupForms(){
    this._router.navigate(['/configsetupforms']);
    
  }

  NavigateviewEditMonthlyHours(){
    this._router.navigate(['/configvieweditmonhr']);
    
  }
  NavigatSetupChecklist(){
    this._router.navigate(['/configsetupchecklist']);
    
  }
  NavigatconfigSetupDepartment(){
    this._router.navigate(['/configsetupdepartment']);
    
  }
 
  NavigatconfigSetupIncident(){
    this._router.navigate(['/configincident']);
    
  }

  NavigatUploadFroms(){
    this._router.navigate(['/form/uploadform']);
    
  }

NavigateTosearchform(){
  this._router.navigate(['/searchform']);

}
NavigateToselectform(){
  this._router.navigate(['/selectform']);

}

NavigatconfigSetupUsers(){
  this._router.navigate(['/administrator']);
  
}

}
